var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmLogoCroppedMirroredLaptop = function SvgSmLogoCroppedMirroredLaptop(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 368,
    viewBox: "0 0 371 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89641 170.194C19.8464 187.477 53.1166 208.284 78.717 223.105L302.565 358.777C328.529 375.594 366.333 366.214 383.072 341.365C383.693 340.43 384.12 339.38 384.327 338.277C384.533 337.174 384.514 336.04 384.273 334.945C384.031 333.849 383.57 332.813 382.919 331.899C382.267 330.986 381.438 330.213 380.481 329.627L63.6106 137.649L9.89641 170.194Z",
    fill: "url(#paint0_radial_418_7266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.259738 137.622C0.240969 149.189 3.60022 160.509 9.9248 170.193C132.563 95.8272 258.078 19.6996 380.457 -54.4328C381.415 -55.0186 382.244 -55.7916 382.895 -56.7053C383.547 -57.619 384.007 -58.6548 384.249 -59.7507C384.491 -60.8465 384.509 -61.9799 384.303 -63.083C384.097 -64.1861 383.67 -65.2363 383.049 -66.1707C366.336 -90.9419 328.479 -100.322 302.516 -83.5054C305.625 -85.3969 236.571 -43.576 73.1744 55.5091C37.5462 77.2228 0.285651 94.6353 0.259738 137.622Z",
    fill: "url(#paint1_radial_418_7266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.569 77.6916C269.454 77.6916 242.61 104.536 242.61 137.65C242.61 170.765 269.454 197.609 302.569 197.609C335.683 197.609 362.527 170.765 362.527 137.65C362.527 104.536 335.683 77.6916 302.569 77.6916Z",
    fill: "#7573FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_418_7266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.519 351.988) rotate(-180) scale(380.223 380.223)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#413FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B428C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_418_7266",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.136 57.7635) rotate(-180) scale(412.95 412.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7573FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BDEB"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmLogoCroppedMirroredLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sm-logo-cropped-mirrored-laptop.650bedd893ef91823cd64c30c550f232.svg";